import * as actionTypes from "./action_type";

const setOrderId = (payload) => {
  return {
    type: actionTypes.HANDBOOK_SET_ORDER_ID,
    payload,
  };
};

const setHandBookTransactionDetails = (payload) => {
  return {
    type: actionTypes.HANDBOOKS_SAVE_TRANSACTION_DETAILS,
    payload,
  };
};

const setTab = (payload) => {
  return {
    type: actionTypes.HANDBOOKS_TAB,
    payload,
  };
};

export default {
  setOrderId,
  setHandBookTransactionDetails,
  setTab,
};
